// Autogenerated locales - do not modify
/* tslint:disable quotemark variable-name */
export const WIKI_PHOTO_FROM_REVIEW_BY_nick = "Zo sk\u00fasenosti od %(nick)s";
export const WIKI_PHOTO_ORIGIN_MANUFACTURER = "Fotografie v\u00fdrobcu";
export const WIKI_PHOTO_SHOW_REVIEW = "Zobrazi\u0165 sk\u00fasenos\u0165";
